import { ValidationProblemDetails } from '../store/slices/function/feedback';

// Helper function to handle SerilogResponse from API
export const handleSerilogResponse = (serilogResponse: any) => {
  return {
    id: Math.random().toString(36).substring(2, 15),
    status: serilogResponse.status || serilogResponse.Status,
    message: serilogResponse.message || serilogResponse.Message,
    errorCode:
      (serilogResponse.errorCode || serilogResponse.ErrorCode)?.toString() ||
      null,
    timestamp: serilogResponse.timestamp || serilogResponse.Timestamp,
    environment: serilogResponse.environment || serilogResponse.Environment,
    innerExceptionMessage:
      serilogResponse.innerExceptionMessage ||
      serilogResponse.InnerExceptionMessage,
    exceptionMessage:
      serilogResponse.exceptionMessage || serilogResponse.ExceptionMessage,
    stackTrace: serilogResponse.stackTrace || serilogResponse.StackTrace,
    exceptionSource:
      serilogResponse.exceptionSource || serilogResponse.ExceptionSource,
    exceptionData:
      serilogResponse.exceptionData || serilogResponse.ExceptionData || null,
    alert: true,
  };
};

export const handleValidationProblemDetails = (
  validationProblemDetails: ValidationProblemDetails,
) => {
  // Converte errors em string no formato "(Key) : (Valor)"
  const errorsString = Object.entries(validationProblemDetails.errors)
    .map(([key, values]) => `(${key}) : (${values.join(', ')})`)
    .join('\n');

  return {
    id: validationProblemDetails.traceId ?? null,
    status: 'WARNING',
    message: validationProblemDetails.title,
    errorCode: validationProblemDetails.status.toString(),
    timestamp: null,
    environment: 'DEVELOPMENT',
    exceptionMessage: errorsString,
    stackTrace: 'ValidationProblemDetails',
    exceptionSource: 'ValidationProblemDetails',
    exceptionData: {
      errors: validationProblemDetails.errors,
      formattedErrors: errorsString,
    },
    alert: true,
    innerExceptionMessage: 'ValidationProblemDetails',
  };
};

/**
 * A function that logs objects to the console in development mode, replacing the standard console.log.
 * @param message A string that explains the logged object
 * @param optionalParams The logged object
 */
export const devLog = (message?: string, ...optionalParams: any[]): void => {
  if (process.env.NODE_ENV === 'development') {
    message !== undefined
      ? console.log(message, ...optionalParams)
      : console.log(null, ...optionalParams);
  }
};

/**
 * A function that logs objects, has warnings, to the console in development mode, replacing the standard console.warn.
 * @param message A string that explains the logged object
 * @param optionalParams The logged object
 */
export const devWarn = (message?: string, ...optionalParams: any[]): void => {
  if (process.env.NODE_ENV === 'development') {
    message !== undefined
      ? console.warn(message, ...optionalParams)
      : console.warn(null, ...optionalParams);
  }
};

/**
 * A function that logs objects, has errors, to the console in development mode, replacing the standard console.error.
 * @param message A string that explains the logged object
 * @param optionalParams The logged object
 */
export const devError = (message?: string, ...optionalParams: any[]): void => {
  if (process.env.NODE_ENV === 'development') {
    message !== undefined
      ? console.error(message, ...optionalParams)
      : console.error(null, ...optionalParams);
  }
};
